import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {Subscription} from 'rxjs';
import * as Redux from 'redux';
import {NgxSpinnerService} from 'ngx-spinner';
import * as TabsActions from '@iv/store/tabs/tabs.actions';
import * as ColumnsActions from '@iv/store/columns/columns.actions';
import {getColumnsEntities} from '@iv/store/columns/columns.selectors';
import {getCurrentTab} from '@iv/store/tabs/tabs.selectors';
import {Instrument} from '@iv/model/instrument';
import {
  FavouritesService
} from '../../services/favourites.service';
import {CommonService} from 'app/core/services/common.service';
import {DxAutocompleteComponent} from 'devextreme-angular/ui/autocomplete';
import {DxSelectBoxComponent} from 'devextreme-angular/ui/select-box';
import {GridComponent} from '@iv/shared/components/grid/grid.component';
import {AppState} from '@iv/store/app.reducer';
import {AppStore} from '@iv/store/app.store';
import {
  getCurrentGroup,
  getDefaultGroups,
  getGroups
} from '../../redux/favorites.reducer';
import * as FavoritesActions from '../../redux/favorites.actions';
import {getAllInstruments} from '@iv/store/instruments/instrument.reducer';
import Utils from '@iv/shared/utils';
import {OptionsCalculatorComponent} from 'app/calculators/options-calculator/options-calculator.component';
import {ProbabilityCalculatorComponent} from 'app/calculators/probability-calculator/probability-calculator.component';
import {ScreenersDropdownComponent} from '../screeners-dropdown/screeners-dropdown.component';
import {GroupDropdownComponent} from '../group-dropdown/group-dropdown.component';
import {ColumnsChooserComponent} from '@iv/shared/components/grid/columns-chooser/columns-chooser.component';
import {ColorThemeService} from 'app/common/services/color-theme.service';
import {ThemeColor} from 'app/common/enums/theme-color.enum';
import {getPermissions} from '@iv/store/permissions/permissions.reducer';
import {PermissionTypes} from '@iv/store/permissions/permissions.models';
import {Group} from '@iv/model/group';
import {FormControl, FormGroup} from '@angular/forms';
import {IPresetGroups, IScreenerSettings} from 'app/favourites/redux/favorites.model';
import {TuiDialogContext, TuiDialogService} from '@taiga-ui/core';
import {PolymorpheusContent,PolymorpheusComponent} from '@tinkoff/ng-polymorpheus';
import {PaymentWindowService} from '../../../payment-window.service';
import { IUploadInsrumentsResultContext } from 'app/model/uploadInstuments';
import { ColumnsChooserTreeComponent, favouritesSettingsDialogOutput } from 'app/shared/components/grid/columns-chooser-tree/columns-chooser-tree.component';


@Component({
  selector: 'iv-live-my-favourites',
  templateUrl: './favourites.component.html',
  styleUrls: ['./favourites.component.scss']
})
export class FavouritesComponent implements OnInit, OnDestroy {

  protected readonly JSON: JSON = JSON;
  uploadFileInstruments: File;
  selectGroupUpload: Group;

  public dropdownLoaderInstrumentsControl = new FormControl('dropdownLoaderInstruments');


  constructor(
    private _favoritesService: FavouritesService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    @Inject(AppStore) private store: Redux.Store<AppState>,
    private readonly colorThemeService: ColorThemeService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    private readonly paymentWindowService: PaymentWindowService
  ) {
    this.unsubscribeStore = store.subscribe(() => this.updateState());
    this.updateState();
  }

  get instruments(): Instrument[] {
    return this._instruments;
  }

  @Input() set instruments(value: Instrument[]) {
    this._instruments = value;
  }

  get selectedGroup(): any {
    return this._selectedGroup;
  }

  set selectedGroup(value: any) {
    const oldId = this.selectedGroup.id;
    const checkbox = document.querySelector('.checkbox_cell_header input') as HTMLInputElement;
    if (value && (oldId !== value.id) && this.visibleColumns) {
      this._selectedGroup = value;
      this.store.dispatch(TabsActions.updateTabData({
        name: 'description',
        value: value.name
      }));
      this.getGroupData(true, true, () => {
        this.gridVisibleColumns = this.getGridVisibleColumns();
        if (checkbox && checkbox.checked) checkbox.checked = false;
      });
    }
  }

  private static MAX_GROUP_INSTRUMENTS = 200;

  private isLoadFirst = true;
  public themeColor: ThemeColor;
  public themeColorEnum = ThemeColor;
  public presetSelectedGroups: IPresetGroups = {
    volume: {id: 14, name: 'All USA', isDefault: true},
    ivxMean: {id: 14, name: 'All USA', isDefault: true},
    historicalRange: {id: 14, name: 'All USA', isDefault: true},
    change: {id: 14, name: 'All USA', isDefault: true},
    skew: {id: 14, name: 'All USA', isDefault: true}
  }
  public deleteGroupPopupVisible: boolean = false;
  public calculatorType: 'options' | 'probability' = 'options';
  weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Th', 'Fri', 'Sat'];
  month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  gridVisibleColumns: any[];
  presetGridVisibleColums: any[] = [];
  currentPresetDirection: string = 'desc'
  advancedSearchVisible = false;
  mode: PermissionTypes = getPermissions(this.store.getState()).find(permission => {
    return permission === PermissionTypes.DELAYED_STOCKS || permission === PermissionTypes.RT_STOCKS;
  });
  isDelayed = this.mode === PermissionTypes.DELAYED_STOCKS;
  isRt = this.mode === PermissionTypes.RT_STOCKS;
  currentGroupStocks: any[] = null;
  currentGroupStocksPreset: any[] = null;
  currentShowTopQuantity = 5;
  selectedStocks: any[] = [];
  stockName = '';
  groups: Group[] = [];
  defaultGroups: Group[] = [];
  defaultColumns: any[] = [];
  visibleColumns: string[];
  settingColumns: any[] = [];
  gridColumns: any[];
  isLoading = false;
  showPresetLoader = false;
  createPopupVisible = false;
  editColumnsPopupVisible = false;
  unsubscribeStore;
  presetDirectionSub = new Subscription();
  chartsPopupVisible = false;
  // Тот кто будет это переписывать - соболезную "instrument.stockid <-> instrument.stockId"
  selectedInstrument: any = {};
  calculatorsPopupPopupVisible = false;
  updloadInstrumentsResultPopup = false;
  uploadInstrumentsResultContext: IUploadInsrumentsResultContext = {
    allCount:0, uploadedCount:0, notUploaded:'', groupName: '', secondsExchange: []
  }
  uploadInstrumentsError = false
  popupCredit = false;
  isEODOptions = false;
  isEODProbability = false;
  regionIdOptions: number;
  regionIdProbability: number;
  @ViewChild(ScreenersDropdownComponent, {static: false}) screenersDropdown !: ScreenersDropdownComponent;
  @ViewChild(GroupDropdownComponent, {static: false}) groupDropdown !: GroupDropdownComponent;
  @ViewChild(ColumnsChooserComponent, {static: false}) columnsChooser !: ColumnsChooserComponent;
  @ViewChild(GridComponent, {static: false}) dataGrid !: GridComponent;
  @ViewChild(DxSelectBoxComponent, {static: false}) selectBox !: DxSelectBoxComponent;
  @ViewChild(DxAutocompleteComponent, {static: false}) autocomplete !: DxAutocompleteComponent;
  @ViewChild(OptionsCalculatorComponent, {static: false}) optionsCalculator !: OptionsCalculatorComponent;
  @ViewChild(ProbabilityCalculatorComponent, {static: false}) probabilityCalculator !: ProbabilityCalculatorComponent;
  @Output() symbolClickEvent = new EventEmitter<any>();
  @Output() dropdownEvent = new EventEmitter<any>();
  private selectedGroupId: any;
  private instrumentsInterval;
  private groupDataSubscription: Subscription;
  private _alwaysVisibleColumns = ['checkbox', 'symbol'];
  private sorting = {};
  private NYDateTime;
  emptyMessage = 'Data not found';
  private _skipPresetRefreshTick = false;
  public isError = false;
  public openGroupDialog: boolean = false;
  public selectedGroupToAddSymbol: Group = {}
  private _instruments: Instrument[] = [];

  private _selectedGroup: any = {};

  currentPreset = 0;

  protected readonly sessionStorage: Storage = sessionStorage;

  private static _getSorting() {
    return {
      'symbol': 'asc'
    };
  }

  radioButtonsForm = new FormGroup({
    radioButton: new FormControl('5'),
  });

  openDropdown(i: number) {
    if (i === 0) {
      this.groupDropdown.showDropdown = false;
    }
    if (i === 1) {
      this.screenersDropdown.showDropdown = false;
    }
    this.dropdownEvent.emit();
  }


  onFileSelected(event) {
    const file: File = event.target.files[0];
    this.uploadFileInstruments = file;
  }

  screenerColumns(column: string[]): void {
    let sort = {};
    const columns = this.visibleColumns.map(x => x);

    if (this.selectedGroupId === 7 ||
      this.selectedGroupId === 8 ||
      this.selectedGroupId === 15 ||
      this.selectedGroupId === 16 ||
      this.selectedGroupId === 28 ||
      this.selectedGroupId === 30) {
      column.shift();
      columns.push(...column);
      sort = {
        [column[0]]: 'desc'
      };
    } else {
      columns.push(...column);
      sort = {
        [column[0]]: 'desc'
      };
    }
    this.onColumnSwitch(columns);
    this.store.dispatch(TabsActions.updateTabData({
      name: 'sorting',
      value: sort
    }));
    this.sortData();
    this.columnsChooser.updateColumns();
  }

  applyScreeners() {
    const checkbox = document.querySelector('.checkbox_cell_header input') as HTMLInputElement;
    this.getGroupData(true, true, () => {
      this.gridVisibleColumns = this.getGridVisibleColumns();
      if (checkbox && checkbox.checked) checkbox.checked = false;
    });
    this.emptyMessage = 'Data not found';
  }

  updateState() {
    const state = this.store.getState();
    const columnsConfig = getColumnsEntities(state)['Favorites'];
    const currentTab = getCurrentTab(state);
    const data = currentTab.data;
    if (data) {
      this.selectedGroupId = data.selectedGroupId;
      this.visibleColumns = data.visibleColumns;
      this.sorting = data.sorting;
    }
    this.defaultColumns = columnsConfig;
    this.groups = getGroups(state);
    this.defaultGroups = getDefaultGroups(state);
    this.selectedGroup = getCurrentGroup(state);
    this.instruments = getAllInstruments(state);
  }

  ngOnInit(): void {
    this.paymentWindowService.showPaymentWindow();
    if (this.mode === PermissionTypes.DELAYED_STOCKS) {
      this._favoritesService.mode = 'DELAYED'
    } else if (this.mode === PermissionTypes.RT_STOCKS) {
      this._favoritesService.mode = 'RT'
    }
    this.mode.toLowerCase()  // TODO: убрать lowercase если не нужен
    this.themeColor = this.colorThemeService.getColorTheme();
    this._favoritesService.currentPreset.subscribe((currentPreset: number) => {
      this.currentPreset = currentPreset;
    })
    this._favoritesService.getCurrentDate().then((response: any) => {
      this.NYDateTime = new Date(response.toString());
      this.setCustomPreset();
      this.loadPreset()
      this.setCurrentPreset(this.currentPreset, true);
    });
    this.presetDirectionSub = this._favoritesService.presetDirection.subscribe((direction: string) => {
      this.currentPresetDirection = direction;
      this.refreshCurrentPreset()
    });
    this.refreshGridDataInterval();
    this.setPresetSelectedGroupsFromStorage()

    this.dropdownLoaderInstrumentsControl.valueChanges.subscribe(value => {
      this.selectGroupUpload = value;
    });

  }

  isMarketClose() {
    return !(!this.isWeekend()
      && (this.NYDateTime.getTime() - this.getStartMarkterDate().getTime() >= 0)
      && (this.NYDateTime.getTime() - this.getEndMarkterDate().getTime() <= 0)
    );
  }

  getEndMarkterDate() {
    return this.getDateWithHours(16, 15 + (this.isDelayed ? 20 : 0));
  }

  getDateWithHours(hour, minute) {
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  isWeekend() {
    const day = new Date().getDay();
    return day === 0 || day === 6;
  }

  getStartMarkterDate() {
    return this.getDateWithHours(9, 30 + (this.isDelayed ? 20 : 0));
  }

  ngOnDestroy(): void {
    if (this.instrumentsInterval) {
      clearInterval(this.instrumentsInterval);
    }
    if (typeof this.unsubscribeStore === 'function') {
      this.unsubscribeStore();
    }
    this.presetDirectionSub?.unsubscribe();
  }

  onCreateGroupClick() {
    this.createPopupVisible = true;
  }

  public showSettingsDialog() {
    this.dialogService
      .open(
        new PolymorpheusComponent(ColumnsChooserTreeComponent),
        {
          data: {
            initColumns: this.visibleColumns,
            allColumns: this.settingColumns
          },
          label: 'Column Settings'
        }
      )
      .subscribe((data: favouritesSettingsDialogOutput)=> {
        if (data.operationType === 'saveColumns') {
          this.onColumnSwitch(data.columns)
        } else {
          this.onColumnSwitch(data.columns)
          this.saveDefault(data.columns)
        }
      });
  }

  onAutocompleteItemClick(e?: any) {
    this.addInstruments([e.itemData.stockId]);
    this.resetAutocomplete();
  }

  onAutocompleteKeyDown(e?: any) {
    const me = this;
    if (e.event.keyCode === 13) {
      let instrumentsToAdd: any = this.stockName
        .replace(/(\w+)(\s+)/g, '$1,')
        .replace(/([,])(\s+)/g, '$1')
        .trim()
        .split(',');
      instrumentsToAdd = instrumentsToAdd.map(stockName => {
        if (stockName !== '') {
          const symbol = stockName.split(':')[0];
          const exchange = stockName.split(':')[1];
          const symbolRegexp = new RegExp('^' + symbol + '$', 'i');
          const exchangeRegexp = (exchange !== undefined) ? new RegExp('^' + exchange + '$', 'i') : undefined;

          const instrument = this.instruments.find(item => {
            return symbolRegexp.test(item.symbol)
              && (exchangeRegexp === undefined || exchangeRegexp.test(item.exchange));
          });

          if (instrument !== undefined) {
            return instrument.stockId;
          }
        }
      }, this);
      this.addInstruments(instrumentsToAdd.filter(item => item));
      me.resetAutocomplete();
    }
  }

  onRemoveSelectedClick() {
    if (!((this._selectedGroup && this._selectedGroup.isDefault === true) || this.selectedStocks.length === 0)) {
      this.removeSelectedStocks();
    }

  }

  onUploadDataClick() {
    this.popupCredit = true;
  }

  onColumnSwitch(columns: string[]) {
    this.editColumnsPopupVisible = false;
    this.store.dispatch(TabsActions.updateTabData({
      name: 'visibleColumns',
      value: columns
    }));
    this.getGroupData(true, true, () => {
      this.gridVisibleColumns = this.getGridVisibleColumns();
    });
  }

  onPopupCancel(popupVisible) {
    this[popupVisible] = false;
  }

  onGroupNameApply(event: { name: string, toggleLoading: () => void } ) {
    const { name, toggleLoading } = event;

    this.saveGroupName(name, toggleLoading);
  }

  saveGroupName(name: string, toggleLoading: () => void) {
    this.screenersDropdown.dropScreener();
    this.emptyMessage = 'Start searching to add data';
    this._favoritesService.createGroup(name).subscribe(data => {
      let type = 'success';
      let text = ('Group was successfully created');
      if (data.RETURN_VALUE === 0 && data.GROUPS_ID > -1) {
        const newGroup = {id: data.GROUPS_ID, name};
        this.store.dispatch(FavoritesActions.addGroup(newGroup));
        this.handleGroupClick(newGroup);
      } else {
        type = 'error';
        text = ('Group was not created. Try again later.');
      }
      toggleLoading();
      this.createPopupVisible = false;
      this.notify(text, type);
    });
  }

  calculatorMessage(event) {
    this.notify(event.message, event.type);
  }

  onRenameGroupApply(name: string) {
    const group = this.selectedGroup;
    if (name !== '') {
      this._favoritesService.renameGroup(group.id, name).subscribe();
    }
  }

  onDeleteGroupApply(event: { deletedGroupId: number, newCurrentGroupId?: number }) {
    this._favoritesService.deleteGroup(event.deletedGroupId)
      .subscribe(p => {
        if (p.RETURN_VALUE === 0) {
          this.store.dispatch(FavoritesActions.deleteGroup(event.deletedGroupId, event.newCurrentGroupId));
          this.store.dispatch(FavoritesActions.selectGroup(event.newCurrentGroupId));
          this.store.dispatch(TabsActions.updateTabData({
            name: 'selectedGroupId',
            value: event.newCurrentGroupId
          }));

          const type = 'success';
          const text = ('Group was successfully deleted');
          this.notify(text, type);
        }
      });
  }

  /***Grid events***/

  toggleAllRowsSelection(selection: boolean) {
    this.currentGroupStocks.forEach(stock => stock.selected = selection);
    this.currentGroupStocks = this.currentGroupStocks.splice(0);
    this.selectedStocks = this.getSelectedStocks();
  }

  onCheckboxClick(event) {
    const row = this.currentGroupStocks.find(stock => stock.stockid === event.stockid);
    row.selected = ((row.selected === undefined || row.selected === false) ? true : undefined);
    this.currentGroupStocks = this.currentGroupStocks.splice(0);
    this.selectedStocks = this.getSelectedStocks();
  }

  onSymbolClick(stockId: number) {
    this.symbolClickEvent.emit(stockId);
  }

  handleSorting(columnName: string) {
    this.changeSortType(columnName);
    this.sortData();
  }

  downloadFile(data: any) {
    const date = new Date();
    Utils.downloadFile(
      data,
      (this.selectedGroup.name + '_' + date.getFullYear() + '_' + (date.getMonth() + 1) + '_' + date.getDate()).split(' ').join('_')
    );
  }

  onSearchButtonClick() {
    this._showAdvancedSearchWindow();
  }

  onAddSymbols(event) {
    this.addInstruments(Array.isArray(event) ? event : [event]);
    this.advancedSearchVisible = false;
  }

  handleGroupClick(group: any) {
    this.currentGroupStocks.forEach(stock => {
      stock.selected = false;
    });
    this.selectedStocks = []

    setTimeout(() => {
      this.store.dispatch(FavoritesActions.selectGroup(group.id));
      this.store.dispatch(TabsActions.updateTabData({
        name: 'selectedGroupId',
        value: group.id
      }));
    }, 300);
  }

  getAllGroups() {
    return [...this.groups, ...this.defaultGroups];
  }

  getGridVisibleColumns() {
    const set = new Set([...this._alwaysVisibleColumns, ...this.visibleColumns]);
    return Array.from(set);
  }

  saveDefault(columns: string[]) {
    this._updateDefaultConfig(columns);
  }

  onRenameGroupClick() {
    document.getElementById('groupInput').focus();
  }

  onChartButtonClicked(instrument: string) {
    this.selectedInstrument = instrument;
    this.chartsPopupVisible = true;
  }

  showDialog(content: PolymorpheusContent<TuiDialogContext>): void {
    this.dialogService.open(content,{size:'m'}).subscribe();
  }

  uploadInstruments(observer): void {
    this._favoritesService.uploadInstruments(this.uploadFileInstruments, this.selectGroupUpload.id).subscribe(response => {
      this.uploadInstrumentsError = false
      observer.complete();
      const value = response.result
      const secondsExchange: Array<string> = response.secondsExchange
      let notUploaded = '';
      let isShowMessage = false;
      let allCount = 0;
      let uploadedCount = 0;
      for (let prop in value) {
        if (!value.hasOwnProperty(prop) || this.findSymbolInSecondsExchange(prop, secondsExchange)) continue;
        allCount++;
        if (!value[prop]) {
          if (notUploaded !== '') {
            notUploaded = notUploaded + `, ${prop}`;
          } else {
            notUploaded = notUploaded + `${prop}`;
          }
          isShowMessage = true;
        } else {
          uploadedCount++;
        }
      }
      this.uploadFileInstruments = undefined;
      this.selectGroupUpload = undefined;
      this.dropdownLoaderInstrumentsControl.setValue(undefined);
      if (allCount === 0) {
        this.commonService.sendNotification(`File is empty.`, 'error');
        return;
      } else {
        this.showUploadInstrumentsResultPopup(allCount, uploadedCount, notUploaded, this.selectedGroup.name, secondsExchange)
      }
      this.refreshCurrentPreset();
    },
    (_err) => {
      this.uploadInstrumentsError = true
      this.updloadInstrumentsResultPopup = true
      observer.complete()
    });

  }

  private showUploadInstrumentsResultPopup(allCount: number, uploadedCount: number, notUploaded: string, groupName: string, secondsExchange: Array<string>): void {
    this.uploadInstrumentsResultContext = {
      allCount,
      uploadedCount,
      notUploaded,
      groupName,
      secondsExchange
    }
    this.updloadInstrumentsResultPopup = true;
  }

  private findSymbolInSecondsExchange(symbol:string, secondsExchange: Array<string>): boolean {
    let isSymbolInSecondsExchange = false
    secondsExchange.forEach((item) => {
      if (symbol === item.slice(0, item.lastIndexOf(":"))) isSymbolInSecondsExchange = true
    })
    return isSymbolInSecondsExchange
  }

  onCalculatorButtonClick(instrument?) {
    this.selectedInstrument = instrument;
    this.calculatorsPopupPopupVisible = true;
  }

  closeCalculatorWindow() {
    this.onPopupCancel('calculatorsPopupPopupVisible');
    this.optionsCalculator.clearAll();
    this.probabilityCalculator.clearAll();
    this.selectedInstrument = null;
  }

  switchCalculatorMode(): void {
    this.switchModeOptions();
    this.switchModeProbability();
  }

  private switchModeOptions(): void {
    this.optionsCalculator?.switchMode();
    this.isEODOptions = !this.isEODOptions;
  }

  private switchModeProbability(): void {
    this.probabilityCalculator?.switchMode();
    this.isEODProbability = !this.isEODProbability;
  }

  returnRegionOptions(region: number): void {
    this.regionIdOptions = region;
    if (this.regionIdOptions === 2 || this.regionIdOptions === 3 || this.regionIdOptions === 4) {
      this.isEODOptions = true;
    }
  }

  returnRegionProbability(region: number): void {
    this.regionIdProbability = region;
    if (this.regionIdProbability === 2 || this.regionIdProbability === 3 || this.regionIdProbability === 4) {
      this.isEODProbability = true;
    }
  }

  /**GRID EVENTS**/

  closeOptionsDropdown() {
    this.optionsCalculator.closeOptionsDropdown();
  }

  closeProbabilityDropdown() {
    this.probabilityCalculator.closeProbabilityDropdown();
  }

  getStockType(item: any) {
    return Utils.getStockType(item);
  }

  private _getDayOfWeek(index) {
    return this.weekday[index];
  }

  private _getMonth(index) {
    return this.month[index];
  }

  private _updateHeaderTime() {
    try {
      const isClose = this.isMarketClose();
      const timeContent = `${this._getDayOfWeek(this.NYDateTime.getDay())}, ${this._getMonth(this.NYDateTime.getMonth())} ${this.NYDateTime.getDate()}, ${this.NYDateTime.getFullYear()}
      <br/>${(isClose ? 'market closed' : (this.isRt ? 'real-time mode' : '20-min delayed mode'))}`;
      window.parent.postMessage({message: 'timeHeaderContent', value: timeContent}, '*');
    } catch (e) {
    }
  }

  private getGroupData(stopPrevious, hasMask, callback?) {
    if (this.selectedGroup) {
      if (hasMask) {
        this.isLoading = true;
        this.spinner.show('favouritesSpinner');
      }
      if (stopPrevious && (this.groupDataSubscription && !this.groupDataSubscription.closed)) {
        this.groupDataSubscription.unsubscribe();
        this._loadData(callback);
      } else if (this.groupDataSubscription === undefined || this.groupDataSubscription.closed) {
        this._loadData(callback);
      }
    }
  }

  private hideSpinner(): void {
    if (this.isLoading) {
      this.isLoading = false;
      this.spinner.hide('favouritesSpinner');
    }
  }

  private _loadData(callback?) {
    const {screenerType, termType, tradeDatePeriod, period, percent} = this.getScreenerData()

    this.groupDataSubscription = this._favoritesService.getGroupData(
      this.mode,
      this.selectedGroup.id,
      this._getColumnsToLoad(false),
      screenerType,
      termType,
      tradeDatePeriod,
      period,
      percent,
      this.isLoadFirst
    ).subscribe(
      response => {
        const data = response.body;
        if (response.status === 200) {
          if (this.isLoading) {
            this.spinner.hide('favouritesSpinner');
            this.isLoading = false;
          }
          if (this.currentGroupStocks) {
            // set selected value
            const array = data.filter(stock => stock.stockid);
            array.forEach(stock => {
              const item = this.currentGroupStocks.filter(i => {
                return i.stockid === stock.stockid;
              })[0];
              if (item !== null && item !== undefined) {
                stock.selected = item.selected === undefined ? undefined : item.selected;
              }
            });
            this.currentGroupStocks = array;
          } else {
            this.currentGroupStocks = data.filter(stock => stock.stockid !== undefined);
          }
          if (callback) {
            callback(this);
          }
        }
      },
      (err) => {
        if (this.isLoading) {
          this.spinner.hide('favouritesSpinner');
          this.isLoading = false;
        }
      }
    );
    this.isLoadFirst = false;
  }

  private isGroupExist(name) {
    return this.groups.some(group => group.name === name);
  }

  private notify(text, type) {
    this.commonService.sendNotification(text, type);
  }

  private removeSelectedStocks() {
    const instrumentsToDelete = [];
    const selectedStocks = this.getSelectedStocks();
    selectedStocks.forEach(function (instrument) {
      if (instrument != null) {
        instrumentsToDelete.push(instrument.stockid);
      }
    }, this);
    this._favoritesService.deleteInstrument(this.selectedGroup.id, instrumentsToDelete).subscribe(data => {
      if (data.RETURN_VALUE === 0) {
        this.getGroupData(true, true);
        this.selectedStocks = [];
      }
    });
  }

  private getSelectedStocks(): any {
    return this.currentGroupStocks.filter(instrument => instrument.selected === true);
  }

  private addInstruments(instrumentsIds: number[]) {
    const group = this.selectedGroup;
    if (group.isDefault) {
      // create group then add instruments
      let newName = group.name + '.1';
      if (this.isGroupExist(newName)) {
        newName += '.1';
      }
      this._favoritesService.createGroup(newName).subscribe(data => {
        if (data.RETURN_VALUE === 0 && data.GROUPS_ID > -1) {
          const ids = this.currentGroupStocks.map(stock => stock.stockid);
          this._favoritesService.addInstruments(data.GROUPS_ID, [...ids, ...instrumentsIds]).subscribe(p => {
            if (p.RETURN_VALUE === 0) {
              const newGroup = {id: data.GROUPS_ID, name: newName};
              this.store.dispatch(FavoritesActions.addGroup(newGroup));
              this.handleGroupClick(newGroup);
            }
          });
        }
      });
    } else if ((this.currentGroupStocks.length + instrumentsIds.length) > FavouritesComponent.MAX_GROUP_INSTRUMENTS) {
      this.notify(`Up to ${FavouritesComponent.MAX_GROUP_INSTRUMENTS} tickers is allowed.
      Please delete one or more tickers to add a new one.`, 'error');
    } else {
      this._favoritesService.addInstruments(this.selectedGroup.id, instrumentsIds).subscribe(p => {
        if (p.RETURN_VALUE === 0) {
          this.getGroupData(true, true);
        }
      });
    }
  }

  private resetAutocomplete() {
    if (this.autocomplete) {
      this.autocomplete.instance.reset();
    }
  }

  uploadData() {
    this.popupCredit = false;
    this.isError = false;
    const screenerType = this.screenersDropdown ? this.screenersDropdown.screenerType : undefined;
    const termType = this.screenersDropdown ? this.screenersDropdown.termType : undefined;
    const tradeDatePeriod = this.screenersDropdown ? this.screenersDropdown.tradeDatePeriod : undefined;
    const period = this.screenersDropdown ? this.screenersDropdown.period : undefined;
    const percent = this.screenersDropdown ? this.screenersDropdown.percent : undefined;

    if (this.currentGroupStocks.length > 0) {
      const selectedStocks = this.getSelectedStocks();
      const ids = (selectedStocks.length > 0) ? selectedStocks : [];
      this._favoritesService.uploadDataBlob(
        this.selectedGroup.id,
        this.mode,
        ids.map((item) => item ? item.stockid : null),
        this._getColumnsToLoad(true),
        this.selectedGroup.name,
        screenerType,
        termType,
        tradeDatePeriod,
        period,
        percent
      )
        .subscribe(data => {
          this.downloadFile(data);
        }, error => {
          this.isError = true;
          this.popupCredit = true;
        });
    }
  }

  private _getVisibleColumns() {
    return this.visibleColumns.filter(item => item !== 'checkbox');
  }

  private sortData() {
    const columns = Object.assign({}, this.gridColumns);
    const sorting = this.sorting;
    if (Object.entries(sorting).length === 0) {
      for (const column in columns) {
        if (columns[column].sortDirection) {
          delete columns[column].sortDirection;
        }
      }
    } else {
      for (const column in columns) {
        if (sorting[column]) {
          columns[column].sortDirection = sorting[column];
        } else {
          delete columns[column].sortDirection;
        }
      }
    }
    this.gridColumns = columns;
  }

  private _showAdvancedSearchWindow() {
    this.advancedSearchVisible = true;
  }

  private _updateDefaultConfig(columns: string[]) {
    this.store.dispatch(ColumnsActions.updateColumnsConfig({
      name: 'Favorites',
      value: columns
    }));
  }

  private _updateTabData(name, value) {
    this.store.dispatch(TabsActions.updateTabData({
      name: name,
      value: value
    }));
  }

  private changeSortType(dataField: string) {
    const sortTypes = {
      'asc': 'desc',
      'desc': '',
      '': 'asc'
    };

    const newSortType = sortTypes[this.sorting[dataField]] ?? 'asc';

    if (newSortType === '') {
      this.currentGroupStocks = this.currentGroupStocks.splice(0);
    }

    const sort = { [dataField]: newSortType };

    this.store.dispatch(TabsActions.updateTabData({
      name: 'sorting',
      value: sort
    }));
  }

  private _getColumnsToLoad(removeGroup?: boolean) {
    const columns = [];
    if (this.visibleColumns.indexOf('quotetime') > -1) {
      columns.push(...['atclose_eod', 'updatedate']);
    }
    if (this.visibleColumns.indexOf('ivx30highlow') > -1) {
      columns.push(...['ivxhigh30_eod', 'ivxlow30_eod']);
    }
    if (this.visibleColumns.indexOf('ivx60highlow') > -1) {
      columns.push(...['ivxhigh60_eod', 'ivxlow60_eod']);
    }
    if (this.visibleColumns.indexOf('ivx90highlow') > -1) {
      columns.push(...['ivxhigh90_eod', 'ivxlow90_eod']);
    }
    if (this.visibleColumns.indexOf('ivx120highlow') > -1) {
      columns.push(...['ivxhigh120_eod', 'ivxlow120_eod']);
    }
    if (this.visibleColumns.indexOf('ivx150highlow') > -1) {
      columns.push(...['ivxhigh150_eod', 'ivxlow150_eod']);
    }
    if (this.visibleColumns.indexOf('ivx180highlow') > -1) {
      columns.push(...['ivxhigh180_eod', 'ivxlow180_eod']);
    }
    if (this.visibleColumns.indexOf('ivx30highlowdate') > -1) {
      columns.push(...['ivxhighdate30_eod', 'ivxlowdate30_eod']);
    }
    if (this.visibleColumns.indexOf('ivx60highlowdate') > -1) {
      columns.push(...['ivxhighdate60_eod', 'ivxlowdate60_eod']);
    }
    if (this.visibleColumns.indexOf('ivx90highlowdate') > -1) {
      columns.push(...['ivxhighdate90_eod', 'ivxlowdate90_eod']);
    }
    if (this.visibleColumns.indexOf('ivx120highlowdate') > -1) {
      columns.push(...['ivxhighdate120_eod', 'ivxlowdate120_eod']);
    }
    if (this.visibleColumns.indexOf('ivx150highlowdate') > -1) {
      columns.push(...['ivxhighdate150_eod', 'ivxlowdate150_eod']);
    }
    if (this.visibleColumns.indexOf('ivx180highlowdate') > -1) {
      columns.push(...['ivxhighdate180_eod', 'ivxlowdate180_eod']);
    }
    const set = new Set(['atclose_eod', 'updatedate', ...this._getVisibleColumns(), ...columns]);
    let array = Array.from(set);
    if (removeGroup) {
      array = array.filter(value => {
        return value !== 'ivx30highlow' &&
          value !== 'ivx60highlow' &&
          value !== 'ivx30highlowdate' &&
          value !== 'ivx60highlowdate' &&
          value !== 'ivx90highlowdate' &&
          value !== 'ivx120highlowdate' &&
          value !== 'ivx150highlowdate' &&
          value !== 'ivx180highlowdate' &&
          value !== 'regionid' &&
          value !== 'ivx90highlow' &&
          value !== 'ivx120highlow' &&
          value !== 'ivx150highlow' &&
          value !== 'ivx180highlow' &&
          value !== 'quotetime';
      });
    }
    return array;
  }

  setCurrentPreset(presetNumber: number, reloadPreset: boolean): void {
    if (this.currentPreset === presetNumber && !reloadPreset) return;
    switch (presetNumber) {
      case 0:
        this.setCustomPreset();
        this._favoritesService.setCurrentPreset(presetNumber);
        break;
      case 1: {
        setTimeout(() => this.showPresetLoader = true, 0)
        this._favoritesService
          .getVolumePreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.volume.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                this.presetGridVisibleColums.push(visibleColumn);
              }
              this._favoritesService.setShowDirectionLoader(false);
              this._favoritesService.setCurrentPreset(presetNumber);
              this.showPresetLoader = false;
              // setTimeout(() => this.showPresetLoader = false,0)
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(this.currentPreset);
              this.showPresetLoader = false;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
      case 2: {
        setTimeout(() => this.showPresetLoader = true, 0)
        this._favoritesService
          .getIVXvsHVPreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.ivxMean.id
          )
          .subscribe((data) => {
            this.currentGroupStocksPreset = data;
            this.presetGridVisibleColums = [];
            for (let visibleColumn in data[0]) {
              this.presetGridVisibleColums.push(visibleColumn);
            }
            this._favoritesService.setShowDirectionLoader(false);
            this.showPresetLoader = false;
            this._favoritesService.setCurrentPreset(presetNumber);
          },
          (_error) => {
            this._favoritesService.setCurrentPreset(this.currentPreset);
            this.showPresetLoader = false;
            this.notify("Failed to load, please try again later", "error");
          }
          );
        break;
      }
      case 3: {
        setTimeout(() => this.showPresetLoader = true, 0)
        this._favoritesService
          .getIVXRangePreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.historicalRange.id
          )
          .subscribe((data) => {
            this.currentGroupStocksPreset = data;
            this.presetGridVisibleColums = [];
            for (let visibleColumn in data[0]) {
              if (visibleColumn === "ivxlow30" || visibleColumn === "ivxhigh30")
                continue;
              this.presetGridVisibleColums.push(visibleColumn);
            }
            this.presetGridVisibleColums.push("ivx30highlow");
            this._favoritesService.setShowDirectionLoader(false);
            this.showPresetLoader = false;
            this._favoritesService.setCurrentPreset(presetNumber);
          },
          (_error) => {
            this._favoritesService.setCurrentPreset(this.currentPreset);
            this.showPresetLoader = false;
            this.notify("Failed to load, please try again later", "error");
          }
          );
        break;
      }
      case 4: {
        setTimeout(() => this.showPresetLoader = true,0)
        this._favoritesService
          .getIVXChangePreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.change.id
          )
          .subscribe((data) => {
            this.currentGroupStocksPreset = data;
            this.presetGridVisibleColums = [];
            for (let visibleColumn in data[0]) {
              this.presetGridVisibleColums.push(visibleColumn);
            }
            this._favoritesService.setShowDirectionLoader(false);
            this.showPresetLoader = false;
            this._favoritesService.setCurrentPreset(presetNumber);
          },
          (_error) => {
            this._favoritesService.setCurrentPreset(this.currentPreset);
            this.showPresetLoader = false;
            this.notify("Failed to load, please try again later", "error");
          }
          );
        break;
      }
      case 5: {
        setTimeout(() => this.showPresetLoader = true,0)
        this._favoritesService
          .getVolSkewPreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.skew.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                this.presetGridVisibleColums.push(visibleColumn);
              }
              this._favoritesService.setShowDirectionLoader(false);
              this.showPresetLoader = false;
              this._favoritesService.setCurrentPreset(presetNumber);
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(this.currentPreset);
              this.showPresetLoader = false;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
    }
    this._skipPresetRefreshTick = true;
  }

  private refreshCurrentPreset(): void {
    switch (this.currentPreset) {
      case 0: {
        this.getGroupData(false, false, () => {});
        break;
      }
      case 1: {
        this._favoritesService
          .getVolumePreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.volume.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                this.presetGridVisibleColums.push(visibleColumn);
              }
              this._favoritesService.setShowDirectionLoader(false);
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(0);
              this.showPresetLoader = true;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
      case 2: {
        this._favoritesService
          .getIVXvsHVPreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.ivxMean.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                this.presetGridVisibleColums.push(visibleColumn);
                this._favoritesService.setShowDirectionLoader(false);
              }
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(0);
              this.showPresetLoader = true;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
      case 3: {
        this._favoritesService
          .getIVXRangePreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.historicalRange.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                if (
                  visibleColumn === "ivxlow30" ||
                  visibleColumn === "ivxhigh30"
                )
                  continue;
                this.presetGridVisibleColums.push(visibleColumn);
              }
              this.presetGridVisibleColums.push("ivx30highlow");
              this._favoritesService.setShowDirectionLoader(false);
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(0);
              this.showPresetLoader = true;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
      case 4: {
        this._favoritesService
          .getIVXChangePreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.change.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                this.presetGridVisibleColums.push(visibleColumn);
              }
              this._favoritesService.setShowDirectionLoader(false);
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(0);
              this.showPresetLoader = true;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
      case 5: {
        this._favoritesService
          .getVolSkewPreset(
            this.currentShowTopQuantity,
            this.currentPresetDirection,
            this.presetSelectedGroups.skew.id
          )
          .subscribe(
            (data) => {
              this.currentGroupStocksPreset = data;
              this.presetGridVisibleColums = [];
              for (let visibleColumn in data[0]) {
                this.presetGridVisibleColums.push(visibleColumn);
              }
              this._favoritesService.setShowDirectionLoader(false);
            },
            (_error) => {
              this._favoritesService.setCurrentPreset(0);
              this.showPresetLoader = true;
              this.notify("Failed to load, please try again later", "error");
            }
          );
        break;
      }
    }
  }

  changeShowTopQuantity(quantity: number): void {
    if (this.currentShowTopQuantity === quantity || this.showPresetLoader) return
    this.currentShowTopQuantity = quantity;
    this.setCurrentPreset(this.currentPreset, true)
  }

  private loadPreset(): void {
    this.changeShowTopQuantity(5);
    this.radioButtonsForm.setValue({radioButton: '5'})
  }

  private setCustomPreset(): void {
    this._favoritesService.getColumns().subscribe(data => {
      if (!this.defaultColumns) {
        this._updateDefaultConfig(data.visibleColumns.map(x => x));
      }
      if (!this.visibleColumns) {
        this._updateTabData('visibleColumns', this.defaultColumns);
      }
      if (!this.sorting) {
        this._updateTabData('sorting', FavouritesComponent._getSorting());
      }
      this.settingColumns = Object.values(data.settingColumns).map(x => Object.assign({}, x));
      this.gridColumns = Object.assign({}, data.gridColumns);
      this.sortData();
      this.gridVisibleColumns = this.getGridVisibleColumns();
      if (Object.keys(this.selectedGroup).length === 0) {
        this.store.dispatch(FavoritesActions.selectGroup(this.selectedGroupId));
      }
    });
  }

  private refreshGridDataInterval(): void {
    this.instrumentsInterval = setInterval(() => {
      if (!this._skipPresetRefreshTick) {
        this.refreshCurrentPreset()
      } else {
        this._skipPresetRefreshTick = false;
      }
    }, 20 * 1000);
    this._updateHeaderTime();
  }

  public onPresetGroupChange(selectedGroup: Group) {
    this.presetSelectedGroups[this.getPresetName()] = selectedGroup
    //TODO: убрать запись в localStorage после добавления ручки на сохранение групп в вьюхах
    localStorage.setItem('presetSelectedGroups', JSON.stringify(this.presetSelectedGroups));
    this.setCurrentPreset(this.currentPreset, true)
  }

  public getPresetName(): keyof IPresetGroups {
    switch (this.currentPreset) {
      case 1: {
        return 'volume'
      }
      case 2: {
        return 'ivxMean'
      }
      case 3: {
        return 'historicalRange'
      }
      case 4: {
        return 'change'
      }
      case 5: {
        return 'skew'
      }
      default: {
        throw new Error("preset doesn't exist");
      }
    }
  }

  /**
   TODO: удалить данную функцию после добавления ручки на сохранение групп в вьюхах
   */
  private setPresetSelectedGroupsFromStorage(): void {
    const selectedGroup = JSON.parse(localStorage.getItem('presetSelectedGroups'));
    if (selectedGroup) {
      this.presetSelectedGroups = selectedGroup
    }
  }

  private getScreenerData(): IScreenerSettings {
    const currentTab = getCurrentTab(this.store.getState());
    const {screenerType, termType, tradeDatePeriod, period, percent} = currentTab.data

    return {
      screenerType,
      termType,
      tradeDatePeriod,
      period,
      percent
    }
  }

  public showGroupDialog(): void {
    this.selectedGroupToAddSymbol = {}
    this.openGroupDialog = true
  }
  public onDeleteGroupClick(): void {
    if (!this.defaultGroups.find(group => group.name === this.selectedGroup.name)) {
      this.onDeleteGroupApply({
        deletedGroupId: this.selectedGroup.id,
        newCurrentGroupId: this.defaultGroups[0].id
      });
      this.selectedGroup = this.defaultGroups[0];
    }
    this.deleteGroupPopupVisible = false;
  }

  public addStocksToSelectedGroup(): void {
    const instrumentsIds = this.selectedStocks.map(instrument => instrument.stockid)
    this._favoritesService.getGroupData(this.mode, this.selectedGroupToAddSymbol.id).subscribe(groupData => {
      if ((groupData.body.length + instrumentsIds.length) > FavouritesComponent.MAX_GROUP_INSTRUMENTS) {
        this.notify(`Up to ${FavouritesComponent.MAX_GROUP_INSTRUMENTS} tickers is allowed.
        Please delete one or more tickers to add a new one.`, 'error');
        this.openGroupDialog = false
      } else {
        this._favoritesService.addInstruments(this.selectedGroupToAddSymbol.id, instrumentsIds).subscribe(p => {
          if (p.RETURN_VALUE === 0) {
            this.getGroupData(true, true);
          }
          this.openGroupDialog = false
        });
      }
    })
  }

  public openDeleteGroupDialog(): void {
    this.deleteGroupPopupVisible = true;
  }

  public switchCalculatorType(type: 'options' | 'probability'): void {
    this.calculatorType = type;
  }
}

